
export class MapWithDefault<K, V> extends Map<K, V> {
	constructor(public readonly createDefault: (key: K) => V) {
		super();
	}

	public override get(key: K): V {
		let value = super.get(key);
		if (value === undefined) {
			value = this.createDefault(key);
			super.set(key, value);
		}
		return value;
	}

	public getOrError(key: K): V {
		let value = super.get(key);
		if (value === undefined) {
			throw new Error();
		}
		return value;
	}

	public getOrUndefined(key: K): V | undefined {
		return super.get(key);
	}
}
